import ProductsSearch from '@/js/vue/products-search/products-search.vue';
import { createApp } from 'vue';

const SEARCH_SELECTOR = '.vue-products-search';
const searchElement = document.querySelector<HTMLElement>(SEARCH_SELECTOR);

export function initProductsSearch() {
  if (!searchElement)
    return;
  const app = createApp(ProductsSearch);
  app.mount(searchElement);
}
